import { z } from "zod";
import { ConnectProto } from "@racoon/api";

export const organizationLabelSchema = z.object({
  name: z.string().trim().min(1, "organizationLabels.dialog.nameRequired").max(255),
});
export type OrganizationLabelFormValues = z.infer<typeof organizationLabelSchema>;

/** The settings tabs built on ConnectProto.OrganizationLabel; also their i18n key prefix. */
export type OrganizationLabelKind = "pickupLocationTypes" | "customerTypes";

/** Writes of one label kind, already scoped to the organization whose labels they are. */
export interface OrganizationLabelMutations {
  create: (name: string) => Promise<unknown>;
  update: (
    id: bigint,
    change: { name?: string; status?: ConnectProto.LocationStatus },
  ) => Promise<unknown>;
}
